import { httpsCallable } from "firebase/functions"

import { useCloudFunction } from "../../../hooks/useCloudFunction"
import { firebase } from "../../../services/firebase/firebase"
import { AwsIotDeleteGroupData } from "../../../functions/aws/iot/aws-iot-deleteGroup"
import { useLanguage } from "../../../contexts/language-context"
import { GroupDocument } from "../../../contexts/devices-context"

export default (group: GroupDocument, onClose: () => void) => {
    const { onStart, onSuccess, onError, processing } = useCloudFunction("aws-iot-deleteGroup")
    const { L } = useLanguage()

    const onDelete = () => {
        onStart(L("Deleting group..."))
        httpsCallable<AwsIotDeleteGroupData>(
            firebase.functions,
            "aws-iot-deleteGroup",
        )({ id: group.id, organisation: group.organisation })
            .then(onSuccess(L("Group deleted successfully")))
            .then(onClose)
            .catch(onError(L("Something went wrong whilst %s!", L("deleting the group"))))
    }

    return { onDelete, processing }
}
